import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="booking-sheet"
export default class extends Controller {
  connect() {
    alert("HELLO");
  }
}
